import styled, { keyframes } from 'styled-components'

export const Button = styled.button`
	background: linear-gradient(90.43deg, #dcf831 53.94%, #79da29 99.89%);
	font-size: 18px;
	font-weight: 500;
	height: 40px;
	border-radius: 20px;
	display: flex;
	align-items: center;
	position: relative;
	overflow: hidden;
	padding: 0 54px;
`

export const ArrowsContainer = styled.div`
	position: absolute;
	right: 10px;
	background: none;
	display: flex;
	gap: 0px;
	z-index: 0;
`

export const TextContainer = styled.span`
	position: relative;
	z-index: 1;
	background-color: transparent;
`

const ArrowKeyFrames = ($maxOpacity: number) => keyframes`
	100% {
		opacity: ${$maxOpacity};
	}
	50% {
        opacity: 0;
	}
	0% {
        opacity: ${$maxOpacity}
	}
`

export const Arrow = styled.span<{ $maxOpacity: number }>`
	animation: ${props => ArrowKeyFrames(props.$maxOpacity)} 2s infinite;
	background-color: transparent;
`
